interface ICaseType {
  id: number;
  valueObject:any;
}

interface ICase {
  id: number;
  caseNo: number;
  caseDate: string; // ISO tarih string olarak gelir
  caseType: ICaseType;
  patientInformations: {
    id: number;
    firstName: string;
    lastName: string;
  };
  caseInformations: {
    id: number;
    assuranceType: any;
    priceType: any;
  };
  provisionNo: string | null;
}

interface IPaymentType {
  id: number;
  valueObject: any; // eğer detaylı tipini biliyorsan açabilirsin
}

export enum BillStatusEnum {
  BILLED = 'BILLED',
  NOT_BILLED = 'NOT_BILLED',
  CANCEL = 'CANCEL',
  APPROVE_CANCEL='APPROVE_CANCEL' //vaka onay kaldırılınca
}

export enum BillTypeEnum {
  MANUEL = 'MANUEL',
  AUTOMATIC = 'AUTOMATIC',
  PROVISION = 'PROVISION',
}
export enum ERPStatusEnum {
  CANCEL = 'CANCEL',
  SENDED = 'SENDED',
  FAILED = 'FAILED',
}

export enum ELogoStatusEnum {
  CANCEL = 'CANCEL',
  SENDED = 'SENDED',
  FAILED = 'FAILED',
}

export interface IBillItem {
  id: number;
  institutionName?: string | null;
  taxOffice?: string | null;
  taxNo?: string | null;
  personFullname?: string | null;
  personIdNumber?: string | null;
  address?: string | null;
  phone?: string | null;
  email?: string | null;
  billStatus: BillStatusEnum;
  eLogoStatus?: ELogoStatusEnum;
  erpStatus?: ERPStatusEnum;
  amount: number;
  vatFreeAmount: number;
  kdvAmount: number;
  kdvRate: string;
  description?: string | null;
  paymentType?: IPaymentType | null;
  cases: ICase;
  billDetails: BillDetails[];
  firstServiceName?: string;
  isClosedDate: boolean;
  kkProvisionNo: string | null;
  erp: any;
  eArchiveStatus: any;
  eArchiveStep: any;
  isSendEmail: boolean | null;
  billType: BillTypeEnum;
  originalBillType: BillTypeEnum;
  billingDate:Date|null;
  billNo:string;
  billPrintedFormSettings: {
    id: number;
    services: any[];
    type: 'MULTI' | 'SINGLE';
  } | null;
}

interface BillDetails {
  service: { id:number,name: string; serviceGroup: any };
  quantity:number
}
export interface IGetNotBilledListResponse {
  success: boolean;
  items: IBillItem[];
}

export interface IGetBilledListResponse {
  success: boolean;
  items: IBillItem[];
  total: number;
  first: number;
  rows: number;
  totalPages: number;
}
export enum BillLogTypeEnum {
  BILL_CREATE = 'BILL_CREATE',
  SEND_ELOGO = 'SEND_ELOGO',
  APPROVE_CANCEL = 'APPROVE_CANCEL',
  E_ARCHIVE_STATUS='E_ARCHIVE_STATUS',
  DOCUMENT_EMAIL='DOCUMENT_EMAIL',
  BILL_CANCEL='BILL_CANCEL',
  ERP_CANCEL='ERP_CANCEL',
  E_LOGO_CANCEL='E_LOGO_CANCEL',
  SEND_ERP="SEND_ERP"
}
